import React, { useEffect, useState } from 'react';
import { Typography, Container, IconButton, CircularProgress } from '@material-ui/core'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage, injectIntl } from 'react-intl'
import MaterialTable from 'material-table';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { NotificationActions, ConfirmPaymentActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
    },
    amount: {
        fontSize: '14px',
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const confirmPaymentSelector = (state) => state.ConfirmPayment;
const IdentitySelector = (state) => state.Identity;

const PaymentMerchantList = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const confirmPaymentActions = bindActionCreators(ConfirmPaymentActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { list, nowWainting } = useSelector(confirmPaymentSelector);
    //const { token } = useSelector(IdentitySelector);
    const { token, userData } = useSelector(IdentitySelector);

    const { classes, intl } = props;

    const listDefinition = {
        columns: [
            {
                // 加盟店名（MaterialTable は columns を deep equal するため JSX 不可）
                title: intl.formatMessage({ id: 'Adjustment.MerchantName' }),
                field: 'merchant_name',
                filtering: true
            },
            {
                // 加盟店タイプ
                title: intl.formatMessage({ id: 'Adjustment.MerchantType' }),
                field: 'merchant_type',
                lookup: {
                    acquirer: '代表',
                    general: '一般',
                },
                filtering: true
            },
        ]
    };

    /**
     *
     * Similar to componentDidMount and componentDidUpdate:
     * 
     * 第2引数に[]を渡すとマウント時のみ呼び出される
     */
    useEffect(() => {
        if (props.refresh == null || props.refresh == true) {

            // 沖縄ICカードの場合、代表加盟店のみ
            if (userData.role == 2) {
                confirmPaymentActions.listAcquirers(token)
                    .then(data => {
                    })
                    .catch(e => {
                        notificationActions.showError(e.message);
                    });
            } else {
                confirmPaymentActions.listMerchants(token)
                    .then(data => {
                    })
                    .catch(e => {
                        notificationActions.showError(e.message);
                    });
            }
        }

    }, []);

    /**
     * 
     * 詳細ボタン押下時の処理
     * 
     * @param data 選択された行のデータ 
     */
    const onDetailClick = (data) => {
        props.onDetail(data.id, data.merchant_name, data.merchant_type);
    }
    
    const placeholder = <FormattedMessage id="Table.Action" />;

    return (
        <Container className={classes.root} maxWidth={false}>
            <MaterialTable
                title={<Typography component="h1" variant="inherit">{<FormattedMessage id="Adjustment.PaymentMerchantList" />}</Typography>}
                columns={listDefinition.columns}
                data={list}
                options={{
                    search: false,
                    filtering: true,
                    actionsColumnIndex: -1,
                }}
                localization={{
                    body: {
                        emptyDataSourceMessage: <FormattedMessage id="Table.EmptyDataSourceMessage" />
                    },
                    header: {
                        actions: ''
                    },
                }}
                components={{
                    // 右端のアクションボタン列（詳細画面遷移ボタン）
                    Action: actionProps => {
                        if (actionProps.action.tooltip !== "Add") {
                             return (
                                 <IconButton aria-label="detail" onClick={() => onDetailClick(actionProps.data)}>
                                     <ArrowForwardIosIcon />
                                 </IconButton>
                             )
                        } else {
                            return (
                                <div></div>
                            )
                        }
                    },
                }}
                editable={{
                    onRowAdd: newData => { },
                    onRowUpdate: (newData, oldData) => { }
                }}
            />
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(injectIntl(PaymentMerchantList));
